import React, { useState, useEffect, useContext } from "react";
import * as S from "./styles";

import PessoaJuridica from "../../assets/navbar/Pessoa_juridica_on.svg";
import Usuario from "../../assets/navbar/Usuario_on.svg";
import Convenios from "../../assets/navbar/Convenios_on.svg";
import Agentes from "../../assets/navbar/Agentes_on.svg";
import Lojas from "../../assets/navbar/Lojas_on.svg";
import LupaOn from "../../assets/navbar/Lupa_on.svg";
import InputText from "../InputText";
import InputSearch from "../InputSearch";
import TransferPoPup from "../TransferPopUp";

import Button from "../../components/Button";
import SkeletonListItem from "../SkeletonListItem";

import api from "../../services/api";

import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";

import { toast } from "react-toastify";

import { Context } from "../../context/globalContext";
import { mask, unMask } from "../../utils/mask";
import desmaskIfNumber from "../../utils/desmaskIfNumber";

import CheckBox from "../Checkbox";

import BorderForSelectNumberOfRecords from "../BorderForSelectNumberOfRecords";
import BorderForSort from "../BorderForSort";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";
import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../Button-v2";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

export default function ListStore({
  history,
  pageFilter,
  filter,
  state,
  stateName,
  type,
}) {
  const { setIsLoading, isLoading } = useContext(Context);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const { pageLimit, setPageLimit } = useContext(Context);

  const [stores, setStores] = useState([]);
  const [searchStateName, setSearchStateName] = useState("");
  const [search, setSearch] = useState("");
  const [searchState, setSearchState] = useState("");
  const [searchType, setSearchType] = useState("LOJA");

  const [transferMode, setTransferMode] = useState(false);
  const [transferModeButton, setTransferModeButton] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [userSelected, setUserSelected] = useState([]);

  const [orderDirection, setorderDirection] = useState("ASC");
  const [orderByColumn, setorderByColumn] = useState("nome_loja");
  const [sortIndex, setSortIndex] = useState(0);

  const [isChecked, setIsChecked] = useState(false);

  async function getDataByStoreCnpj(cpfCnpj, state, type, page) {
    try {
      setIsLoading(true);
      const response = await api.get(
        `api/loja/buscar?${type !== "" ? `type=${type}` : ""}${
          cpfCnpj !== "" ? `&cnpjOuNome=${cpfCnpj}` : ""
        }${state !== "" ? `&uf=${state}` : ""}&page=${
          page || 0
        }&size=${pageLimit}&sort=${orderByColumn},${orderDirection}`
      );

      if (response && (response.status === 201 || response.status === 200)) {
        setStores(response.data.content);
        setPage(page || 0);
        setTotalPages(response.data.totalPages);
        setTotalElements(response.data.totalElements);
      } else if (!response) {
        setPage(page || 0);
        setStores([]);
        setTotalPages(0);
        setTotalElements(0);
        toast.error("Erro ao buscar as lojas.");
      }

      setIsLoading(false);
    } catch (err) {
      setPage(page || 0);
      setTotalPages(0);
      setStores([]);
      setTotalElements(0);
      setIsLoading(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar as lojas.");
      }
    }
  }

  useEffect(() => {
    if (filter) {
      setSearch(filter);
    }
    if (state) {
      setSearchState(state);
      setSearchStateName(stateName);
    }

    if (type) {
      setSearchType(type);
    }

    if (pageFilter) {
      setPage(pageFilter);
    }

    getDataByStoreCnpj(filter, state, type, pageFilter);
    checkIfTransfermodeAvailable();
  }, [filter, state, type, pageFilter, pageLimit, sortIndex]);

  const checkIfTransfermodeAvailable = () => {
    let isNum = /^[0-9]+$/.test(unMask(filter));
    if (isNum & (type === "AGENTE") & (state === "")) {
      setTransferModeButton(true);
    } else {
      setTransferModeButton(false);
    }
  };

  const reloadPage = (filter, page) => {
    history.replace(
      `?filter=${desmaskIfNumber(filter.search)}${
        filter.searchType !== "" ? `&type=${filter.searchType}` : ""
      }${
        filter.searchState !== ""
          ? `&uf=${filter.searchState}&ufName=${filter.searchStateName}`
          : ""
      }${page && page > 0 ? "&page=" + page : ""}`
    );
  };

  const selectNumberRegistry = async (item) => {
    setPageLimit(item.id);
  };

  const handleKeyPress = (event) => {
    const value = event.target.value;
    if (event.key === "Enter") {
      reloadPage({
        search,
        searchState,
        searchStateName,
        searchType,
      });
    }
  };

  const verifyIfIsEnabled = (papel, entity, image, url) => {
    if (papel === entity) {
      return (
        <S.SvgIcon
          onClick={() => {
            history.push(`/${url}`);
          }}
          src={image}
          alt=""
        />
      );
    }

    return <S.SvgIconDisabled src={image} alt="" />;
  };

  const handleCheckBox = (item) => {
    const alreadyExists = userSelected.find((store) => store.id === item.id);

    if (alreadyExists) {
      const userFiltred = userSelected.filter(
        (store) => store.id !== alreadyExists.id
      );
      setUserSelected(userFiltred);
    } else {
      setUserSelected((prevState) => [...prevState, item]);
    }
  };

  const updateListFromTransfer = () => {
    setTransferMode(false);
    getDataByStoreCnpj(search, searchState, searchType, page);
  };

  const selectSort = async (item) => {
    setSortIndex(item.id);

    switch (item.sort) {
      case "DESC":
        setorderByColumn("nome_loja");
        setorderDirection("DESC");
        break;
      case "ASC":
        setorderByColumn("nome_loja");
        setorderDirection("ASC");
        break;
      case "DataDESC":
        setorderByColumn("data_registro");
        setorderDirection("DESC");
        break;
      case "DataASC":
        setorderByColumn("data_registro");
        setorderDirection("ASC");
        break;
    }
  };

  return (
    <>
      <S.Container>
        <S.Card>
          <S.SearchWrapper>
            <div className="labelFilter">Filtrar pesquisa</div>
            <div className="boxSearch">
              <S.InputRadioBox>
                <S.InputRadio>
                  <label>
                    <>
                      <input
                        type="radio"
                        name="searchType"
                        className="radio"
                        value={searchType}
                        checked={searchType === "LOJA"}
                        onChange={() => setSearchType("LOJA")}
                      />
                      Loja{" "}
                    </>
                  </label>
                  <label>
                    <>
                      <input
                        type="radio"
                        name="searchType"
                        className="radio"
                        value={searchType}
                        checked={searchType === "AGENTE"}
                        onChange={() => {
                          setSearchType("AGENTE");
                        }}
                      />
                      Agente{" "}
                    </>
                  </label>
                </S.InputRadio>
              </S.InputRadioBox>
              <div className="wrapperInputButton">
                <div className="inputContainer">
                  <span className="inputWrapper">
                    <InputText
                      type="text"
                      name="search"
                      label="CPF, CNPJ ou Nome:"
                      alwaysShowMask={false}
                      autoComplete={"off"}
                      value={search}
                      onKeyPress={(e) => handleKeyPress(e)}
                      onChange={(ev) => setSearch(ev.target.value)}
                    />
                  </span>
                  <span className="inputWrapper">
                    <InputSearch
                      //type="text"
                      name="searchEstado"
                      label="Estado:"
                      type="ESTADO"
                      alwaysShowMask={false}
                      autoComplete={"off"}
                      initialValue={searchStateName}
                      onKeyPress={(e) => handleKeyPress(e)}
                      handleSearch={(ev) => {
                        setSearchStateName(ev?.nome || "");
                        setSearchState(ev?.uf || "");
                      }}
                    />
                  </span>
                </div>
                <S.ButtonWrapper>
                  <Button
                    onClick={() =>
                      reloadPage({
                        search,
                        searchState,
                        searchStateName,
                        searchType,
                      })
                    }
                  >
                    consultar
                  </Button>
                  <Button
                    disabled={!transferModeButton}
                    button={transferModeButton ? "primary" : "secondary"}
                    onClick={() => {
                      //fazer a parte que deixa o tamanho da pagina ilimitado
                      setTransferMode(!transferMode);
                    }}
                  >
                    {!transferMode ? "Modo transferência" : "Cancelar"}
                  </Button>
                </S.ButtonWrapper>
              </div>
            </div>
          </S.SearchWrapper>
          <S.CardHeader>
            <span>
              {`${totalElements} loja${
                totalElements > 1 ? "s" : ""
              } cadastrada${totalElements > 1 ? "s" : ""} no sistema`}
            </span>
            {totalElements > 0 && (
              <span className="border">
                Selecione o icone para acessar o cadastro
              </span>
            )}
          </S.CardHeader>

          {!isLoading ? (
            <S.CardBody>
              {stores &&
                stores?.map((store) => {
                  const itemSelected = !!userSelected.find(
                    (item) => item.id === store.id
                  );

                  return (
                    <>
                      <S.Custumer>
                        <S.Info
                          onClick={() =>
                            history?.push(`/cadastro-lojas/${store?.idPessoa}`)
                          }
                        >
                          <S.SvgIcon src={Lojas} alt="" />
                          <div className="dataCard">
                            <h4>CNPJ:</h4>
                            <h4>Empresa:</h4>
                          </div>
                          <div className="dataCard">
                            <h4 className="h4-info">
                              {mask(
                                store?.cpfCnpjPessoa,
                                "##.###.###/####-##",
                                true
                              )}
                            </h4>
                            <h4 className="h4-info">
                              {store?.nomeLoja + " | " + store?.nomePessoa}
                            </h4>
                          </div>
                        </S.Info>

                        {!transferMode ? (
                          store?.status ? (
                            <div className="iconService">
                              <Button
                                type="button"
                                onClick={() => {
                                  history.push(
                                    `/cadastro-usuario?cnpj=${desmaskIfNumber(
                                      store?.cpfCnpjPessoa
                                    )}`
                                  );
                                }}
                              >
                                <S.SvgIconInvert src={Usuario} alt="" />
                                Adicionar usuário
                              </Button>
                              <S.SvgIcon
                                onClick={() => {
                                  if (
                                    !store?.idPessoa ||
                                    store?.idPessoa === null
                                  ) {
                                    toast.error(
                                      "Esta loja não possui uma pessoa jurídica vinculada!"
                                    );
                                    return;
                                  }

                                  history.push(
                                    `/cadastro-pessoa-juridica/${store?.idPessoa}`
                                  );
                                }}
                                src={PessoaJuridica}
                                alt=""
                              />
                              {verifyIfIsEnabled(
                                store?.agenteTiposEntidadePessoaPapelPJ,
                                "AGENTE",
                                Agentes,
                                `cadastro-agentes/${store?.agenteIdPessoa}`
                              )}
                              {verifyIfIsEnabled(
                                store?.convenioTiposEntidadePessoaPapelPJ,
                                "CONVENIO",
                                Convenios,
                                `cadastro-convenios/${store?.convenioIdPessoa}`
                              )}
                              <S.SvgIcon
                                onClick={() => {
                                  history.push(
                                    `/historico/agente/${store?.idPessoa}`
                                  );
                                }}
                                src={Lojas}
                                alt=""
                              />
                            </div>
                          ) : (
                            <div className="WrapperInativo">
                              <Button className="inativo">
                                Cadastro Inativo
                              </Button>
                            </div>
                          )
                        ) : (
                          <CheckBox
                            marked={itemSelected}
                            onClick={() => handleCheckBox(store)}
                          />
                        )}
                      </S.Custumer>
                    </>
                  );
                })}
              <S.transferButton>
                {!transferMode ? (
                  <></>
                ) : (
                  <Button
                    onClick={() => {
                      if (
                        !userSelected ||
                        userSelected === null ||
                        userSelected.length === 0
                      ) {
                        toast.error("Selecione pelo menos uma loja!");
                        return;
                      }

                      setPopupOpen(true);
                    }}
                  >
                    Transferir
                  </Button>
                )}
              </S.transferButton>
              <div className="rodaPe">
                <div className="select1">
                  <S.SelectContainer>
                    <BorderForSelectNumberOfRecords
                      selected={0}
                      handleSearch={selectNumberRegistry}
                      initialValue={pageLimit}
                    />
                  </S.SelectContainer>
                </div>
                <div className="select">
                  <S.SelectContainer>
                    <BorderForSort
                      selected={0}
                      handleSearch={selectSort}
                      initialValue={sortIndex}
                    />
                  </S.SelectContainer>
                </div>
                <div className="select">
                  {totalPages > 1 && (
                    <TablePagination
                      component="div"
                      classes={{
                        toolbar: classes.toolbar,
                        caption: classes.caption,
                      }}
                      count={totalElements}
                      page={page}
                      labelDisplayedRows={({ from, to, count }) => {
                        return from + " - " + to + " de " + count;
                      }}
                      onPageChange={(p, newPage) => reloadPage(search, newPage)}
                      rowsPerPageOptions={[10]}
                      rowsPerPage={pageLimit}
                    />
                  )}
                </div>
              </div>
            </S.CardBody>
          ) : (
            <SkeletonListItem />
          )}
          <GoTopoButtonWrapper>
            <ButtonV2
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              height="32px"
              leftIcon={IoChevronUp}
            >
              Topo
            </ButtonV2>
          </GoTopoButtonWrapper>
        </S.Card>
      </S.Container>
      {popupOpen && (
        <TransferPoPup
          setIsLoading={setIsLoading}
          setOpenPopup={setPopupOpen}
          itemsSelected={userSelected}
          updateList={updateListFromTransfer}
          page={page}
          endPoint="/api/loja"
          textExclude={"Você deseja realmente excluir este usuário?"}
        />
      )}
    </>
  );
}
